RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    function initialize(properties) {
        if (!RivalIQ.apps.Favorites) {
            return;
        }

        const Dashboards = Backbone.Collection.extend({
            model: RivalIQ.apps.Favorites.models.Configuration,

            comparator: function (a, b) {
                if (a.get('type') !== b.get('type')) {
                    return (a.get('type') === RivalIQ.enums.visibility.ACCOUNT ? -1 : 1);
                }
                return a.get('name').localeCompare(b.get('name'));
            }
        });

        let dashboards = properties.dashboards;
        if (RivalIQ.state.user.isReadOnly()) {
            dashboards = _.reject(properties.dashboards, function (dashboard) {
                return dashboard.type === RivalIQ.enums.visibility.ACCOUNT;
            });
        }

        state.dashboards = new Dashboards(dashboards, {
            parse: true
        });
    }

    state.initializeDashboards = initialize;
});
